import React, { useEffect, useState } from 'react';
import ScheduleWeekItem from './ScheduleWeekItem';
import { GetWeeks } from './API';

const ScheduleWeeks = (props) => {
    window.scrollToSelected();

    const [data, setData] = useState([])
    useEffect(() => {
        GetWeeks(props.batchNum).then(data => {
            console.log(data)
            setData(data);
        })
    }, [])
    return (
        <div class="weeksListContainer">
        {data.map( (item) => <ScheduleWeekItem  item={item} />)}
        </div>
    );
};

export default ScheduleWeeks;


// WEBPACK FOOTER //
// ./src/pages/student_schedule/ScheduleWeeks.js